import { post } from "../../../shared/data";
import { SourcePage } from "shared/taskTypeMap";
export const redoScheduling = (taskId, taskType) => {
    return post(`/coding/wips/${taskId}/redo-scheduling?sourcePage=${SourcePage[taskType]}`);
};

export const validateCoderRole = async (taskKey) => {
    return post(`/tasking/tasks/${taskKey}/user-qualification-checks`);
};
